module.exports = __webpack_public_path__ + "static/media/ruler-vertical.d1f03f73.svg";